var React = require('react');

function Comments (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-171 -560)"},[React.createElement("rect",{"width":"22","height":"22","transform":"translate(171 560)","fill":"none","key":0}),React.createElement("path",{"d":"M2.25,4.25h19.5V21.941L15.764,17.75H2.25Zm1.5,1.5v10.5H16.236l4.014,2.809V5.75Z","transform":"translate(170 558.75)","fill":"#b1b1b1","fillRule":"evenodd","key":1})]));
}

Comments.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Comments;

Comments.default = Comments;
